<div class="dxiu-digicert-dd-spinner no-print" [ngClass]="[size, theme]">
    <img *ngIf="renderText && brand === 'toyota'" src="../../../../assets/images/gifs/red-small-spinner.gif" alt="Loading" class="spinner-text red"
    />
    <img *ngIf="renderText && brand === 'lexus'" src="../../../../assets/images/gifs/black-small-spinner.gif" alt="Loading" class="spinner-text red"
    />
  </div>